import React from 'react';
import {Role} from '../../models/role.model';
import {RoleInfo} from './RoleInfo';
import {PermissionActions} from './PermissionActions';
import {PermissionsContent} from './PermissionsContent';

interface RolePermissionsModalContentProps {
  role: Role;
  selectedPermissions: number[];
  allPermissions: any[];
  hasChanges: boolean;
  assigning: boolean;
  permissionsLoading: boolean;
  loadingRolePermissions: boolean;
  permissionsByCategory: Record<string, any[]>;
  onPermissionToggle: (permissionId: number) => void;
  onSelectAll: (permissions: any[]) => void;
  onDeselectAll: () => void;
  onDeselectCategory?: (categoryPermissions: any[]) => void;
  getResourceDisplayName: (resource: string) => string;
  getActionDisplayName: (action: string) => string;
  onCancel: () => void;
  onSave: () => void;
}

/**
 * Content component for role permissions modal
 */
export const RolePermissionsModalContent: React.FC<RolePermissionsModalContentProps> = ({
  role,
  selectedPermissions,
  allPermissions,
  hasChanges,
  assigning,
  permissionsLoading,
  loadingRolePermissions,
  permissionsByCategory,
  onPermissionToggle,
  onSelectAll,
  onDeselectAll,
  onDeselectCategory,
  getResourceDisplayName,
  getActionDisplayName,
  onCancel,
  onSave
}) => {
  return (
    <div className="space-y-6">
      <RoleInfo role={role} />

      {/* Permissions Content */}
      <div className="max-h-[70vh] overflow-y-auto mb-6">
        <PermissionsContent
          permissionsLoading={permissionsLoading}
          loadingRolePermissions={loadingRolePermissions}
          permissionsByCategory={permissionsByCategory}
          selectedPermissions={selectedPermissions}
          onPermissionToggle={onPermissionToggle}
          onSelectAll={onSelectAll}
          onDeselectAll={onDeselectAll}
          onDeselectCategory={onDeselectCategory}
          getResourceDisplayName={getResourceDisplayName}
          getActionDisplayName={getActionDisplayName}
        />
      </div>

      <PermissionActions
        selectedCount={selectedPermissions.length}
        totalCount={allPermissions.length}
        hasChanges={hasChanges}
        assigning={assigning}
        onCancel={onCancel}
        onSave={onSave}
      />
    </div>
  );
};
